<template>
  <div>
    <user-filters
      :name.sync="payload.name"
      :approved.sync="payload.approved"
      :active.sync="payload.active"
      @apply="getUsers(payload)"
      :action="selected.length > 0"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Users</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            show-select
            v-model="selected"
            :items="users"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <!-- <template v-slot:header.data-table-select="{ props, on }">
               COLOR Not working when props.indeterminate is true
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template> -->
            <template slot="item" slot-scope="props">
              <tr @click="edit(props.item.id)">
                <td @click.stop>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  <v-avatar size="30px">
                    <img :src="props.item.avatar" />
                  </v-avatar>
                </td>
                <td class="text-left" @click.stop>
                  <v-switch
                    @change="toggleActive($event, props.item.id)"
                    color="green"
                    v-model="props.item.active"
                  >
                  </v-switch>
                </td>

                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.firstName }} {{ props.item.lastName }}
                </td>
                <td class="text-left">{{ props.item.email }}</td>
                <td class="text-left">
                  <v-icon> {{ props.item.approved | boolFilter }} </v-icon>
                </td>

                <td class="text-left">
                  {{ props.item.type }}
                </td>
                <td class="text-left">
                  {{ props.item.role }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers";
import UserFilters from "@/components/user_management/UserFilters.vue";
export default {
  components: {
    UserFilters
  },
  mixins: [Helpers],
  props: {
    payload: {
      type: Object,
      default: {
        from: 0,
        to: 10,
        name: " ",
        approved: null,
        active: null
      }
    },
    module: {
      type: String,
      default: "users/LOAD_USERS"
    }
  },
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    },
    boolFilter: function(bool) {
      return bool ? "done" : "close";
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false
        },
        {
          text: "Active",
          align: "left",
          sortable: false
        },
        {
          text: "Created",
          align: "left",
          sortable: false
        },
        {
          text: "Name",
          align: "left",
          sortable: false
        },
        {
          text: "Email",
          align: "left",
          sortable: false
        },
        {
          text: "Approved",
          align: "left",
          sortable: false
        },
        {
          text: "Type",
          align: "left"
        },
        {
          text: "Role",
          align: "left"
        }
      ]
    };
  },
  computed: {
    users() {
      return this.$store.state.users.users;
    },
    totalItems() {
      return this.$store.state.users.totalUsers;
    }
  },
  created() {
    this.getUsers(this.payload);
  },
  methods: {
    select(evt) {
      console.log(evt);
    },
    filterName(value) {
      this.payload.name = value;
      this.getUsers(this.payload);
    },
    filterApproved(value) {
      this.payload.approved = value;
      this.getUsers(this.payload);
    },
    getUsers(payload) {
      this.loading = true;
      this.$store
        .dispatch(this.module, payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getUsers(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        this.getUsers(this.payload);
      }
    },
    toggleActive(state, userId) {
      let title = !state ? "Deactivating user..." : "Activating user...";
      let updateText = !state ? "User deactivated." : "User activated";
      this.$swal({
        title: title,
        html: "this will only take a moment...",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });

      let payLoad = {
        active: state,
        userId: userId
      };

      this.$store
        .dispatch("users/UPDATE_ACTIVE_STATUS", payLoad)
        .then(response => {
          this.$swal("success", updateText, "success");
        })
        .catch(error => {
          this.$swal("error", error.message, "error");
        });
    }
  }
};
</script>
<style lang="scss">
#users {
  .filters {
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
